import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { setToken } from "./lib/api";
import "./styles.css";

// Вход из ЦУПа без пароля (29.08.2026, приказ Pavel «доступ из ЦУП прямой,
// у каждого своя учётка»): ЦУП открывает CRM со своим пропуском в адресе —
// #sso=<jwt>. Пропуск подписан тем же секретом, что и обычный вход, поэтому
// дальше всё работает штатно. Адрес сразу чистим, чтобы пропуск не оставался
// в истории браузера и в ссылках.
(function acceptSsoFromUrl() {
  try {
    const raw = window.location.hash || "";
    const m = raw.match(/[#&]sso=([^&]+)/);
    if (!m) return;
    setToken(decodeURIComponent(m[1]));
    const clean = raw.replace(/[#&]sso=[^&]+/, "");
    window.history.replaceState(null, "", window.location.pathname +
      window.location.search + (clean === "#" ? "" : clean));
  } catch {
    /* пропуск кривой — просто покажем обычный вход */
  }
})();

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
